export const breakpoints = {
  xs: 0,
  sm: 390,
  msm: 568,
  md: 764,
  lg: 1020,
  xl: 1440,
  xxl: 1920,
};
